// social icons
import { FiGithub, FiLinkedin, FiFacebook, FiTwitter } from "react-icons/fi";

const NavbarItem = [
  {
    id: 1,
    text: "home",
    url: "/",
  },
  {
    id: 2,
    text: "about",
    url: "/about",
  },
  // {
  //   id: 3,
  //   text: "projects",
  //   url: "/projects",
  // },
  {
    id: 4,
    text: "contact",
    url: "/contact",
  },
];
export default NavbarItem;

export const RecentProjectsData = [
  {
    project_name: "Devute",
    project_title:
      "Devute Agency Website || Built with Next.js, Redux, and Sass",
    image_url: "./img/project-img-9.png",
    project_link: "https://devute.com",
  },
  {
    project_name: "Xhibiter",
    project_title:
      "Xhibiter a themeforest template made by next.js and tailwind",
    image_url: "./img/project-img-8.png",
    project_link: "https://cutt.ly/WB025Hd",
  },
  {
    project_name: "Patrick",
    project_title: "Patrick - Personal CV vCard React Template",
    image_url: "./img/project-img-7.png",
    project_link: "https://cutt.ly/DB09b6A",
  },
  {
    project_name: "Team Consultency",
    project_title:
      "Team Consultency - A Learning Management Website || Built with Wordpress, and Elementor",
    image_url: "./img/project-img-13.png",
    project_link:
      "https://devute.xyz/projects/2024-projects/01-2024/team-consultancy/",
  },
  // {
  //   project_name: "Rivus DAO",
  //   project_title: "Rivus DAO - Built with Javascript",
  //   image_url: "./img/project-img-15.png",
  //   project_link: "https://www.rivusdao.xyz/",
  // },
  {
    project_name: "Kieke Fotografie",
    project_title: "Kieke Fotografie - Built with Javascript",
    image_url: "./img/project-img-16.png",
    project_link: "https://www.kiekefotografie.nl/",
  },
  {
    project_name: "Ecclbd",
    project_title:
      "A IOT Business application || Built with Wordpress, and Elementor",
    image_url: "./img/project-img-14.png",
    project_link: "https://ecclbd.com/",
  },
  {
    project_name: "royaltychauffeurs",
    project_title:
      "A Car Business application || Built with Wordpress, and Elementor",
    image_url: "./img/project-img-11.png",
    project_link: "https://royaltychauffeurs.co.uk/",
  },
];

export const OtherProjectsData = [
  {
    project_name: "Colonpax",
    project_title: "Developed for FutureINV agency using React, and Bootstrap",
    image_url: "./img/other-project-img-15.png",
    project_link: "https://colonpax.com/",
  },
  {
    project_name: "Maria",
    project_title: "Maria - Personal Model and Designer Portfolio Template",
    image_url: "./img/other-project-img-16.png",
    project_link:
      "https://themeforest.net/item/maria-model-designer-portfolio-template/21604495",
  },
  {
    project_name: "Code degree",
    project_title:
      "An Arabic Learning Management Application, Transformed into a Figma Design",
    image_url: "./img/other-project-img-9.png",
    project_link: "https://codedegree.com/",
  },
  {
    project_name: "Sauzatequila",
    project_title:
      "Sauza Tequila is a company that produces tequila || Transformed into a Figma Design",
    image_url: "./img/other-project-img-10.png",
    project_link: "https://www.sauzatequila.com/",
  },
  {
    project_name: "kitchenheed",
    project_title: "a single page appication using html css and sass",
    image_url: "./img/other-project-img-11.png",
    project_link: "https://kitchenheed.vercel.app/",
  },
  {
    project_name: "Best Company Formation",
    project_title:
      "A LLC Formation Solutions application || build with WordPress, elementor",
    image_url: "./img/other-project-img-17.png",
    project_link: "https://bestcompanyformation.com/",
  },
  {
    project_name: "smart llc guide",
    project_title:
      "A LLC Formation Solutions application || build with WordPress, elementor",
    image_url: "./img/other-project-img-12.png",
    project_link: "https://www.smartllcguide.com/",
  },
  {
    project_name: "top formation web",
    project_title:
      "A LLC Formation Solutions application || build with WordPress, elementor",
    image_url: "./img/other-project-img-13.png",
    project_link: "https://www.topformationweb.com/",
  },
  {
    project_name: "llc formation hub",
    project_title:
      "A LLC Formation Solutions application || build with WordPress, elementor",
    image_url: "./img/other-project-img-14.png",
    project_link: "https://llcformationhub.com/",
  },
];

export const socialLinks = [
  {
    link: "https://github.com/maruf1137",
    icon: <FiGithub />,
  },
  {
    link: "https://linkedin.com/in/maruf1137",
    icon: <FiLinkedin />,
  },
  {
    link: "https://facebook.com/maruf1137",
    icon: <FiFacebook />,
  },
  {
    link: "https://twitter.com/maruf1137",
    icon: <FiTwitter />,
  },
];

export const SkillsData = [
  {
    skill_image: "./img/skill-img-1.png",
    skill_name: "Html",
  },
  {
    skill_image: "./img/skill-img-2.png",
    skill_name: "css",
  },
  {
    skill_image: "./img/skill-img-3.png",
    skill_name: "Javascript",
  },
  {
    skill_image: "./img/skill-img-4.png",
    skill_name: "React.js",
  },
  {
    skill_image: "./img/skill-img-8.png",
    skill_name: "Next.js",
  },
  {
    skill_image: "./img/skill-img-5.png",
    skill_name: "tailwind",
  },
  {
    skill_image: "./img/skill-img-6.png",
    skill_name: "sass",
  },
  {
    skill_image: "./img/skill-img-7.png",
    skill_name: "bootstrap",
  },
  {
    skill_image: "./img/skill-img-9.png",
    skill_name: "Wordpress",
  },
  {
    skill_image: "./img/skill-img-10.png",
    skill_name: "Elementor",
  },
  {
    skill_image: "./img/skill-img-11.png",
    skill_name: "Gsap",
  },
];

export const SoftwareData = [
  {
    skill_image: "./img/software-img-1.png",
    skill_name: "vs code",
  },
  {
    skill_image: "./img/software-img-2.png",
    skill_name: "xd",
  },
  {
    skill_image: "./img/software-img-3.png",
    skill_name: "figma",
  },
  {
    skill_image: "./img/software-img-4.png",
    skill_name: "github",
  },
  {
    skill_image: "./img/software-img-5.png",
    skill_name: "terminal",
  },
  {
    skill_image: "./img/software-img-6.png",
    skill_name: "api",
  },
];
